module.exports = __webpack_public_path__ + "img/diamond-animation-mobile.86bae9bb.png";